import React from 'react';
import { Flex } from '@ui-library/misc';
import classes from './requirements.module.scss';
import { SubtextContainer } from '@components/profile/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { regular } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Subtext } from '@ui-library/typography';

type Props = {
  password: string;
};

const conditions = (value: string) => [
  {
    label: '12 characters',
    condition: value.length >= 12,
  },
  {
    label: 'One upper and lowercase letter',
    condition: value.toUpperCase() !== value && value.toLowerCase() !== value,
  },
  {
    label: 'One number',
    condition: /\d/.test(value),
  },
  {
    label: 'One special character',
    condition: /(?=.*[ !"#$%&'()*+,-./:;<=>?@[\]^_`{|}~])/.test(value),
  },
];

export default ({ password }: Props) => (
  <>
    <Flex alignItems="center" className={classes.header}>
      <FontAwesomeIcon className={classes.lockIcon} icon={regular('lock')} />
      <Subtext>Passwords must include at least:</Subtext>
    </Flex>
    {conditions(password).map((item) => (
      <Flex key={`overlay-item-${item.label}`} alignItems="center" className={classes.itemHeader}>
        <FontAwesomeIcon
          data-testid="tick-mark"
          className={item.condition ? classes.tickIcon : classes.circle}
          icon={item.condition ? regular('circle-check') : regular('circle')}
        />
        <SubtextContainer className={`${classes.headerLabel} ${item.condition ? 'active' : ''}`}>
          {item.label}
        </SubtextContainer>
      </Flex>
    ))}
  </>
);
